import React, { ReactNode } from 'react';

import { ErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary';

import FallbackUI from './FallbackUI';

interface ErrorBoundaryComponentProps extends Omit<ErrorBoundaryProps, 'children'> {
  children: ReactNode;
}

const ReactErrorBoundary: React.FC<ErrorBoundaryComponentProps> = ({ children }) => {
  // use below function to log errors
  const logErrorToService = (error: Error, info: React.ErrorInfo) => {
    console.error('logging an error:', error, info);
  };

  return (
    <ErrorBoundary FallbackComponent={FallbackUI} onError={logErrorToService}>
      {children}
    </ErrorBoundary>
  );
};

export default ReactErrorBoundary;
